import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fea2090a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]

interface Emits {
  (e: "insert-gif", url: string): void;
}

interface Props {
  description: string;
  url: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GifItem',
  props: {
    description: {},
    url: {}
  },
  emits: ["insert-gif"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const insertGif = () => {
  emit("insert-gif", props.url);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    key: _ctx.url,
    src: _ctx.url,
    alt: _ctx.description,
    class: "gif-image",
    onClick: insertGif
  }, null, 8, _hoisted_1))
}
}

})